<template>
  <div class="search">
    <div class="search-container">
      <img src="/icon-search.svg" />
      <form>
        <input type="hidden" name="id" value="search" />
        <input type="hidden" name="t" value="search" />
        <input
          name="search"
          type="search"
          :id="id"
          :placeholder="label"
          :value="value"
          :required="required"
          v-on:input="updateValue($event.target.value)"
          role="textbox"
          tabindex="0"
          autocomplete="off"
          aria-label="search"
          aria-haspopup="true"
        />
      </form>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    id: {
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchTerm: "",
    };
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
};
</script>



<style scoped>
ul.dropdown-menu {
  width: 100%;
  max-width: calc(100% - calc(26px * 2));
  border-radius: 0px 0px 4px 4px;
  margin: 0px;
  margin-left: 26px;
  overflow-y: auto;
  max-height: 600px;
  position: absolute;
  z-index: 200;
}

.search {
  position: relative;
  height: 48px;
  margin: 0;
}
.search-container {
  height: 100%;
  width: 100%;
  border-radius: calc(48px / 2);
  background-color: var(--input-bg, #f2f2f2);
  display: flex;
  align-items: center;
  position: absolute;
  transition: background-color 0.3s;
}
.search-container form {
  width: 100%;
  height: 100%;
}
.search-container input {
  padding-left: 80px;
  background-color: transparent;
  border: 0;
  width: 100%;
  height: 100%;
  color: var(--text-color, black);
  font-size: 1em;
}

.search-container input::placeholder {
  color: var(--text-color, #666);
  opacity: 0.6;
}

.search-container img {
  position: absolute;
  margin-left: 32px;
  opacity: 0.6;
}
</style>